"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationApi = exports.useMarkAllNotificationsReadMutation = exports.useMarkNotificationReadMutation = exports.useGetNotificationQuery = exports.useGetUnreadNotificationCountQuery = exports.useGetNotificationsQuery = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
// Every argument carries the user id so one user's cached notifications are never served to the next.
var notificationApi = (0, react_1.createApi)({
    reducerPath: "notificationApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["notification"],
    endpoints: function (builder) { return ({
        getNotifications: builder.query({
            query: function (_a) {
                var size = _a.size, pageNumber = _a.pageNumber, unread = _a.unread;
                return ({ url: "/v1/notification", params: __assign({ size: size, pageNumber: pageNumber }, (unread ? { unread: "true" } : {})) });
            },
            providesTags: ["notification"],
        }),
        getUnreadNotificationCount: builder.query({
            query: function () { return "/v1/notification/unread-count"; },
            providesTags: ["notification"],
        }),
        getNotification: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/v1/notification/".concat(id);
            },
            providesTags: ["notification"],
        }),
        markNotificationRead: builder.mutation({
            query: function (id) { return ({ url: "/v1/notification/".concat(id, "/read"), method: "PATCH" }); },
            invalidatesTags: ["notification"],
        }),
        markAllNotificationsRead: builder.mutation({
            query: function () { return ({ url: "/v1/notification/read-all", method: "PATCH" }); },
            invalidatesTags: ["notification"],
        }),
    }); },
});
exports.notificationApi = notificationApi;
exports.useGetNotificationsQuery = notificationApi.useGetNotificationsQuery, exports.useGetUnreadNotificationCountQuery = notificationApi.useGetUnreadNotificationCountQuery, exports.useGetNotificationQuery = notificationApi.useGetNotificationQuery, exports.useMarkNotificationReadMutation = notificationApi.useMarkNotificationReadMutation, exports.useMarkAllNotificationsReadMutation = notificationApi.useMarkAllNotificationsReadMutation;
